import { render, staticRenderFns } from "./FieldsGenerator.vue?vue&type=template&id=2005ff42&"
import script from "./FieldsGenerator.vue?vue&type=script&lang=js&"
export * from "./FieldsGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports